import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

const menuForm = {
  label: "",
  url: "",
  target: null,
  parent: null,
  order: null,
  _id: "",
  routeMethod: "internal",
};

// const menuData = {
//   title: "",
//   bannerImage: "",
//   descriptionOne: "",
//   descriptionTwo: "",
// };

// create slice
const name = "menu";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const menuActions = { ...slice.actions, ...extraActions };
export const menuReducer = slice.reducer;

function createInitialState() {
  return {
    CreateMenuItemResponse: {},
    getParentMenuList: [],
    getMenuByIDResponse: {},
    getMenuListResponse: [],
    menuForm: menuForm,
    updateMenuItemResponse: {}, //update api response
    deleteMenuResponse: {},
    getMenuListHomePageResponse: {},
    loading: false,
    // menuData: menuData,
    getMenuResponseData: {},
    UpdateMenuDataResponse: {},
  };
}

function createReducers() {
  return {
    updateMenuForm,
    resetMenuForm,
    updateMenuData,
    resetData,
  };
}

function updateMenuData(state, action) {
  state.menuData = action?.payload;
}

function resetData(state) {
  // state.menuData = { ...menuData };
}

function updateMenuForm(state, action) {
  state.menuForm = action?.payload;
}

function resetMenuForm(state, action) {
  state.menuForm = { ...menuForm };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getParentMenuList: getParentMenuList(), //Menu List
    CreateMenuItem: CreateMenuItem(), //Create new menu item
    getMenuItemByID: getMenuItemByID(),
    updateMenuItem: updateMenuItem(), //Update Menu item
    deleteMenu: deleteMenu(),
    getMenuList: getMenuList(),
    getMenuListHomePage: getMenuListHomePage(),

    //Dynamic menu
    getMenuData: getMenuData(),
    updateMenuPage: updateMenuPage(),
  };

  /* get MenuData */
  function getMenuData() {
    return createAsyncThunk(
      `${name}/getMenuData`,
      async (params) => await fetchWrapper.get(`${baseUrl}/pages${params}`)
    );
  }

  /* Update Menu Page updateMenuPage*/
  function updateMenuPage() {
    return createAsyncThunk(
      `${name}/updateMenuPage`,
      async ({ id, params }) =>
        await fetchWrapper.put(`${baseUrl}/pages/${id}`, params)
    );
  }

  /* get Menu list */
  function getParentMenuList() {
    return createAsyncThunk(
      `${name}/menu-items/parents`,
      //  async (params) => await fetchWrapper.get(`${baseUrl}/committee${params}`)
      async (params) => await fetchWrapper.get(`${baseUrl}/menu-items/parents`)
    );
  }

  /* get MenuItem by ID */
  function getMenuItemByID() {
    return createAsyncThunk(
      `${name}/menu-items`,
      async (id) => await fetchWrapper.get(`${baseUrl}/menu-items/${id}`)
    );
  }

  /* create new Menu Item */
  function CreateMenuItem() {
    return createAsyncThunk(
      `${name}/CreateMenuItem`,
      async (params) => await fetchWrapper.post(`${baseUrl}/menu-items`, params)
    );
  }

  /* create update Menu Item */
  function updateMenuItem() {
    return createAsyncThunk(
      `${name}/updateMenuItem`,
      async (params) =>
        await fetchWrapper.put(`${baseUrl}/menu-items/${params?._id}`, params)
    );
  }

  function deleteMenu() {
    return createAsyncThunk(`${name}/deleteMenu`, async (id) => {
      return await fetchWrapper.delete(`${baseUrl}/menu-items/${id}`, {
        status: false,
      });
    });
  }

  /* get menu list */
  function getMenuList() {
    return createAsyncThunk(
      `${name}/get-menu-items`,
      //  async (params) => await fetchWrapper.get(`${baseUrl}/committee${params}`)
      async (params) => await fetchWrapper.get(`${baseUrl}/menu-items`)
    );
  }

  // Get Menu for home Page
  function getMenuListHomePage() {
    return createAsyncThunk(
      `${name}/menu-items/home`,
      //  async (params) => await fetchWrapper.get(`${baseUrl}/committee${params}`)
      async (params) => await fetchWrapper.get(`${baseUrl}/menu-items/home`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    //Parent menu list
    .addCase(extraActions.getParentMenuList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getParentMenuList.fulfilled, (state, action) => {
      state.loading = false;
      state.getParentMenuList = action?.payload;
    })
    .addCase(extraActions.getParentMenuList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //Get Menu Item by ID
    .addCase(extraActions.getMenuItemByID.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMenuItemByID.fulfilled, (state, action) => {
      state.loading = false;
      state.getMenuByIDResponse = action?.payload;
    })
    .addCase(extraActions.getMenuItemByID.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //create New Menu Item
    .addCase(extraActions.CreateMenuItem.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.CreateMenuItem.fulfilled, (state, action) => {
      state.loading = false;
      state.CreateMenuItemResponse = action?.payload;
    })
    .addCase(extraActions.CreateMenuItem.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //update Menu Item Response
    .addCase(extraActions.updateMenuItem.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.updateMenuItem.fulfilled, (state, action) => {
      state.loading = false;
      state.updateMenuItemResponse = action?.payload;
    })
    .addCase(extraActions.updateMenuItem.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    // Delete Menu Item
    .addCase(extraActions.deleteMenu.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.deleteMenu.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteMenuResponse = action.payload;
    })
    .addCase(extraActions.deleteMenu.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //Get menu list
    .addCase(extraActions.getMenuList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMenuList.fulfilled, (state, action) => {
      state.loading = false;
      state.getMenuListResponse = action?.payload;
    })
    .addCase(extraActions.getMenuList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //Get menu list for Home Page
    .addCase(extraActions.getMenuListHomePage.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMenuListHomePage.fulfilled, (state, action) => {
      state.loading = false;
      state.getMenuListHomePageResponse = action?.payload;
    })
    .addCase(extraActions.getMenuListHomePage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //
    .addCase(extraActions.getMenuData.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.getMenuData.fulfilled, (state, action) => {
      state.loading = false;
      state.getMenuResponseData = action.payload;
    })
    .addCase(extraActions.getMenuData.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //updateMenuPage
    .addCase(extraActions.updateMenuPage.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.updateMenuPage.fulfilled, (state, action) => {
      state.loading = false;
      state.getMenuResponseData = action.payload;
    })
    .addCase(extraActions.updateMenuPage.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    });
}
